/* ==========================================================================
   MONTAGE-THEME · <mt-lightbox>
   --------------------------------------------------------------------------
   Kundenmedien im Vollbild. Klick auf eine Kachel öffnet sie groß, ein X
   oder Escape schliesst wieder.

   Fortschrittliche Verbesserung: ohne dieses Skript bleiben die Kacheln
   ganz normale Kacheln. Das Skript haengt sich erst an, wenn es laeuft,
   und macht die Kacheln dann zu Knoepfen (role, tabindex, aria-label).
   Deshalb steht im Markup kein Knopf, der ohne Skript nichts tut.

   Zugaenglichkeit, bewusst umgesetzt:
     · Der Dialog faengt den Fokus (Tab laeuft im Overlay im Kreis)
     · Escape schliesst, der Fokus kehrt zur Kachel zurueck
     · aria-modal und role="dialog" am Overlay
     · Klick auf den Hintergrund schliesst ebenfalls
     · Beim Oeffnen wird die Seite gegen Scrollen gesperrt
   ========================================================================== */
/* Gekapselt, weil mehrere Sektionen dieselbe Datei einbinden koennen. */
(function () {
  class MontageLightbox extends HTMLElement {
    /* Alle Texte kommen aus den Datenattributen von mt-texte.liquid, also
       aus locales/*.json. Die englischen Rueckfalltexte greifen nur, wenn
       ein Attribut fehlt, und fallen dann bewusst auf. */
    medienText(i) {
      const vorlage = this.dataset.textGross || 'View media {{ index }} of {{ anzahl }} full screen';
      return vorlage
        .replace('{{ index }}', i + 1)
        .replace('{{ anzahl }}', this.kacheln.length);
    }

    connectedCallback() {
      this.kacheln = Array.from(this.querySelectorAll('[data-gross]'));
      if (!this.kacheln.length) return;

      /* ⚠️ Im Theme-Editor setzt Shopify eine Sektion beim Bearbeiten neu ins
            Dokument. connectedCallback laeuft dann ein zweites Mal, und ohne
            diese Bremse haengt eine zweite Vollbildflaeche am body und jede
            Kachel traegt ihre Klickhandler doppelt. Im Laden faellt das nie
            auf, im Editor sofort. */
      if (this.aufgebaut) return;
      this.aufgebaut = true;

      this.kacheln.forEach((kachel, i) => {
        kachel.setAttribute('role', 'button');
        kachel.setAttribute('tabindex', '0');
        kachel.setAttribute('aria-label', kachel.dataset.label || this.medienText(i));
        kachel.classList.add('mt-medium--klickbar');
        kachel.addEventListener('click', () => this.oeffne(i));
        kachel.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.oeffne(i);
          }
        });
      });

      this.baueOverlay();
    }

    disconnectedCallback() {
      /* Der Dialog haengt am body, nicht am Element. Verschwindet die Sektion
         (Editor, Umsortieren), muss er mitgehen, sonst bleibt er als Leiche
         im Dokument stehen. */
      document.removeEventListener('keydown', this.tastatur);
      document.documentElement.classList.remove('mt-lightbox-offen');
      this.overlay?.remove();
      this.aufgebaut = false;
    }

    baueOverlay() {
      this.overlay = document.createElement('div');
      this.overlay.className = 'mt-lightbox';
      this.overlay.setAttribute('role', 'dialog');
      this.overlay.setAttribute('aria-modal', 'true');
      this.overlay.hidden = true;
      this.overlay.innerHTML = `
        <button type="button" class="mt-lightbox__zu" aria-label="${this.dataset.textSchliessen || 'Close'}">
          <svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true">
            <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" fill="none"/>
          </svg>
        </button>
        <button type="button" class="mt-lightbox__pfeil mt-lightbox__pfeil--zurueck" aria-label="${this.dataset.textZurueck || 'Previous media'}">‹</button>
        <div class="mt-lightbox__buehne"></div>
        <button type="button" class="mt-lightbox__pfeil mt-lightbox__pfeil--weiter" aria-label="${this.dataset.textWeiter || 'Next media'}">›</button>`;
      document.body.appendChild(this.overlay);

      this.buehne = this.overlay.querySelector('.mt-lightbox__buehne');
      this.zu = this.overlay.querySelector('.mt-lightbox__zu');
      this.zu.addEventListener('click', () => this.schliesse());
      /* Ueber die Klasse gesucht, nicht ueber die Beschriftung: die
         Beschriftung ist jetzt uebersetzbar und taugt nicht als Selektor. */
      this.overlay
        .querySelector('.mt-lightbox__pfeil--zurueck')
        .addEventListener('click', () => this.oeffne(this.index - 1));
      this.overlay
        .querySelector('.mt-lightbox__pfeil--weiter')
        .addEventListener('click', () => this.oeffne(this.index + 1));

      // Klick auf den Hintergrund schliesst, Klick auf das Medium nicht.
      this.overlay.addEventListener('click', (e) => {
        if (e.target === this.overlay) this.schliesse();
      });

      this.tastatur = (e) => {
        if (e.key === 'Escape') this.schliesse();
        if (e.key === 'ArrowRight') this.oeffne(this.index + 1);
        if (e.key === 'ArrowLeft') this.oeffne(this.index - 1);
        if (e.key === 'Tab') this.haltFokus(e);
      };
    }

    oeffne(index) {
      const letzte = this.kacheln.length - 1;
      if (index < 0) index = letzte;
      if (index > letzte) index = 0;
      this.index = index;

      if (this.overlay.hidden) {
        this.vorherigerFokus = document.activeElement;
        this.overlay.hidden = false;
        document.documentElement.classList.add('mt-lightbox-offen');
        document.addEventListener('keydown', this.tastatur);
      }

      // Das Medium wird geklont, damit das Original in der Reihe bleibt.
      const quelle = this.kacheln[index].querySelector('video, img, svg');
      this.buehne.innerHTML = '';
      if (quelle) {
        const klon = quelle.cloneNode(true);
        // ⚠️ Der Klon bringt die Groessenangaben der KACHEL mit (width,
        //    height, inline styles). Ohne Zuruecksetzen bleibt er im
        //    Vollbild so klein wie in der Reihe.
        klon.removeAttribute('width');
        klon.removeAttribute('height');
        klon.removeAttribute('style');
        klon.classList.add('mt-lightbox__medium');
        if (klon.tagName === 'VIDEO') {
          klon.controls = true;
          klon.muted = false;
          klon.autoplay = true;
          klon.loop = true;
          klon.setAttribute('playsinline', '');
        }
        if (klon.tagName === 'IMG') {
          // Grosse Fassung laden, nicht die Vorschau der Kachel
          klon.removeAttribute('srcset');
          klon.removeAttribute('sizes');
          klon.loading = 'eager';
        }
        this.buehne.appendChild(klon);
      }
      this.zu.focus();
    }

    schliesse() {
      this.overlay.hidden = true;
      this.buehne.innerHTML = '';
      document.documentElement.classList.remove('mt-lightbox-offen');
      document.removeEventListener('keydown', this.tastatur);
      // Der Fokus kehrt dahin zurueck, wo er herkam.
      this.vorherigerFokus?.focus();
    }

    /* Tab laeuft im Overlay im Kreis, damit der Fokus nicht dahinter
       verschwindet, waehrend der Dialog offen ist. */
    haltFokus(e) {
      const ziele = this.overlay.querySelectorAll('button, video');
      if (!ziele.length) return;
      const erste = ziele[0];
      const letzte = ziele[ziele.length - 1];
      if (e.shiftKey && document.activeElement === erste) {
        e.preventDefault();
        letzte.focus();
      } else if (!e.shiftKey && document.activeElement === letzte) {
        e.preventDefault();
        erste.focus();
      }
    }
  }

  if (!customElements.get('mt-lightbox')) {
    customElements.define('mt-lightbox', MontageLightbox);
  }
})();
